import { createMongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';
import { createContext } from 'react';

import type {
    Abilities,
    AppAbility,
    Authentication,
} from '@barboxx/models/types';

export const ability = createMongoAbility<Abilities>();

export const AbilityContext = createContext(null as unknown as AppAbility);
export const Can = createContextualCan(AbilityContext.Consumer);

export function updateAbility(
    ability: AppAbility,
    user?: Authentication.AuthReturn['user']
) {
    ability.update(user?.rules ?? []);
}
